var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0235958 11.363L0 11.3535V15.6923C0 16.2148 0.423595 16.6384 0.946127 16.6384C1.19706 16.6384 1.43771 16.5387 1.61514 16.3613L3.78445 14.1919H15.1616C16.7292 14.1919 18 12.9211 18 11.3535V2.83838C18 1.27079 16.7292 0 15.1616 0H2.86197C1.29438 0 0.0235958 1.27079 0.0235958 2.83838V11.363Z",
    fill: "#52B3A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7424 8.51416C14.5262 8.51416 15.1616 7.87877 15.1616 7.09497C15.1616 6.31117 14.5262 5.67578 13.7424 5.67578C12.9586 5.67578 12.3232 6.31117 12.3232 7.09497C12.3232 7.87877 12.9586 8.51416 13.7424 8.51416ZM9.0118 8.51416C9.7956 8.51416 10.431 7.87877 10.431 7.09497C10.431 6.31117 9.7956 5.67578 9.0118 5.67578C8.228 5.67578 7.59261 6.31117 7.59261 7.09497C7.59261 7.87877 8.228 8.51416 9.0118 8.51416ZM4.28117 8.51416C5.06496 8.51416 5.70036 7.87877 5.70036 7.09497C5.70036 6.31117 5.06496 5.67578 4.28117 5.67578C3.49737 5.67578 2.86198 6.31117 2.86198 7.09497C2.86198 7.87877 3.49737 8.51416 4.28117 8.51416Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.15119c7eee59960496cbf99c93d16cd4.svg";
export { ForwardRef as ReactComponent };